module.exports = __webpack_public_path__ + "img/bg.0a7f30de.jpg";